import { ConfigProvider } from 'antd';
import BaseBouton, { BtnProps } from './BaseButton';

const DisabledFilledButton = (props: BtnProps) => {
    const components = {
        Button: {
            defaultColor: '#fff',
            defaultBg: '#aaa',
            defaultBorderColor: '#aaa',
            defaultHoverColor: '#fff',
            defaultHoverBg: '#999',
            defaultHoverBorderColor: '#999',
            defaultHoverCursor: 'not-allowed',
        },
    };
    return (
        <ConfigProvider theme={{ components }}>
            <BaseBouton {...props} />
        </ConfigProvider>
    );
};

export default DisabledFilledButton;
